import React, { Fragment, ReactNode } from 'react';
import { infoIcon2 } from './Icons';

const CurrMonthLossStrip: React.FC<{
    currMonthLoss?: number;
    className?: string;
    textClassName?: string;
    icon?: ReactNode;
}> = ({ currMonthLoss, className, icon, textClassName }) => {
    return currMonthLoss !== undefined ? (
        <div
            className={`flex items-center ${
                currMonthLoss <= 0 ? 'abha-linked-inner-more' : 'abha-linked-inner-less'
            } px-12 py-4 ${className ?? 'gap-8'}`}
        >
            {currMonthLoss <= 0 ? (
                <Fragment>
                    <span className="font-700 text-12">₹</span>
                    <p className="text-12">
                        <span className="font-700">Earn up to ₹100</span> by linking 5 records per
                        patient
                    </p>
                </Fragment>
            ) : (
                <Fragment>
                    <span>{icon ?? infoIcon2('fill-darwin-neutral-1000')}</span>
                    <p className={textClassName ?? 'text-12'}>
                        Link <span className="font-700">{currMonthLoss} more records</span> this
                        month to earn incentives from NHA
                    </p>
                </Fragment>
            )}
        </div>
    ) : null;
};

export default CurrMonthLossStrip;
